import { CheckIcon } from "@codat/orchard-ui";
import classNames from "classnames";
import React, { ComponentPropsWithRef, forwardRef } from "react";

import styles from "./Radio.module.css";

interface RadioProps extends ComponentPropsWithRef<"input"> {
  id: string;
  label: React.ReactNode;
  checked?: boolean;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { value, label, id, checked, defaultChecked = false, onClick, ...otherProps },
  ref
) {
  return (
    <div className={styles.container} data-testid="radio">
      <input
        className={classNames({ [styles.checkbox]: checked !== undefined })}
        id={id}
        value={value}
        type={checked !== undefined ? "checkbox" : "radio"}
        data-testid="radio-input"
        defaultChecked={defaultChecked}
        ref={ref}
        onClick={onClick}
        {...otherProps}
      />{" "}
      <label htmlFor={id} className={styles.label} data-testid="radio-label">
        {checked && <CheckIcon className={classNames(styles.checkIcon)} />}
        <span>{label}</span>
      </label>
    </div>
  );
});
